import { render } from "./employee-details.vue?vue&type=template&id=09d8f6ab"
import script from "./employee-details.vue?vue&type=script&lang=js"
export * from "./employee-details.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__